/* angular:styles/component:css;f9adee9321a203811f42fb20f7c27c10f5422125ce920b5f2389db100430f39a;/usr/src/app/src/app/features/details/components/details-vod/details-vod.ts */
:host ::ng-deep asset-card {
  width: 100% !important;
  height: auto !important;
  aspect-ratio: 16 / 9;
  margin-right: 0 !important;
}
/*# sourceMappingURL=details-vod.css.map */
